import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE = "https://cafvoice.org";

function upsertMeta(sel, attrs) {
  let el = document.head.querySelector(sel);
  if (!el) {
    el = document.createElement("meta");
    Object.entries(attrs.selector || {}).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  Object.entries(attrs.set || {}).forEach(([k, v]) => el.setAttribute(k, v));
  return el;
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
  el.setAttribute("href", href);
  return el;
}

function upsertJsonLd(id, data) {
  let el = document.head.querySelector(`script[data-jsonld="${id}"]`);
  if (!el) { el = document.createElement("script"); el.type = "application/ld+json"; el.setAttribute("data-jsonld", id); document.head.appendChild(el); }
  el.textContent = JSON.stringify(data);
  return el;
}

export const SEO = ({ title, description, image, type = "website", jsonLd, breadcrumbs }) => {
  const { pathname } = useLocation();
  const url = `${SITE}${pathname}`;
  const fullTitle = title ? `${title} — Citizen Awareness Foundation` : "Citizen Awareness Foundation — Awareness Creates Change";
  const desc = description || "India-focused non-profit driving awareness, transparency and civic action.";
  const img = image || `${SITE}/logo-caf.png`;

  useEffect(() => {
    document.title = fullTitle;
    upsertMeta('meta[name="description"]', { selector: { name: "description" }, set: { name: "description", content: desc } });
    upsertLink("canonical", url);
    // OG
    upsertMeta('meta[property="og:title"]', { selector: { property: "og:title" }, set: { property: "og:title", content: fullTitle } });
    upsertMeta('meta[property="og:description"]', { selector: { property: "og:description" }, set: { property: "og:description", content: desc } });
    upsertMeta('meta[property="og:url"]', { selector: { property: "og:url" }, set: { property: "og:url", content: url } });
    upsertMeta('meta[property="og:image"]', { selector: { property: "og:image" }, set: { property: "og:image", content: img } });
    upsertMeta('meta[property="og:type"]', { selector: { property: "og:type" }, set: { property: "og:type", content: type } });
    // Twitter
    upsertMeta('meta[name="twitter:card"]', { selector: { name: "twitter:card" }, set: { name: "twitter:card", content: "summary_large_image" } });
    upsertMeta('meta[name="twitter:title"]', { selector: { name: "twitter:title" }, set: { name: "twitter:title", content: fullTitle } });
    upsertMeta('meta[name="twitter:description"]', { selector: { name: "twitter:description" }, set: { name: "twitter:description", content: desc } });
    upsertMeta('meta[name="twitter:image"]', { selector: { name: "twitter:image" }, set: { name: "twitter:image", content: img } });

    if (jsonLd) upsertJsonLd("page-schema", jsonLd);
    if (breadcrumbs && breadcrumbs.length) {
      upsertJsonLd("breadcrumb", {
        "@context": "https://schema.org", "@type": "BreadcrumbList",
        itemListElement: breadcrumbs.map((b, i) => ({ "@type": "ListItem", position: i + 1, name: b.name, item: `${SITE}${b.href}` })),
      });
    }
  }, [fullTitle, desc, url, img, type, JSON.stringify(jsonLd), JSON.stringify(breadcrumbs)]);

  return null;
};
